var map = {
	"./blocks/accordion/frontend.js": 8008,
	"./blocks/newsletter/frontend.js": 9111,
	"./entrypoints/neuron/slider/frontend.js": 8524,
	"./entrypoints/neuron/twoclickvideo/frontend.js": 9046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 836;